"use client";

import { useTranslation } from "react-i18next";
import { Icon } from "@iconify-icon/react";

import TemplateApplyDialog from "./TemplateApplyDialog";

import { Button } from "@/components/ui/button";
import { useCalendarStore } from "@/features/calendar/store/useCalendarStore";

export default function TemplateApplyButton() {
  const { t } = useTranslation(["calendar"]);
  const { dateRange } = useCalendarStore();

  const handleOpenDialog = () => {
    // Dispatch a custom event to open the dialog
    const event = new CustomEvent("openTemplateApplyDialog", {
      detail: { dateRange },
    });

    window.dispatchEvent(event);
  };

  return (
    <>
      <Button className="gap-1.5" size="sm" variant="foreground" onClick={handleOpenDialog}>
        <Icon height="18" icon="tabler:template" width="18" />
        <span className={"hidden sm:inline"}>{t("calendar:templates.applyTemplate")}</span>
      </Button>
      <TemplateApplyDialog />
    </>
  );
}
